import type { FestiveGame } from "../../types";

export const festiveGames: FestiveGame[] = [
  {
    id: "ultimate-familiar",
    name: "Ultimate Familiar",
    description: [
      {
        type: "paragraph",
        text: "This game is open to any Warlock with a Familiar. Each participant takes turns sending their Familiar through an obstacle course, putting on a show for the watching crowd.",
      },
    ],
    scoring: [
      "1–10 points for fastest completion time. The quickest Familiar gets 10 points, second gets 9, and so on.",
      "1–10 points for showpersonship while completing the course — tricks, flips, rolls, and general panache.",
      "1–10 points for how stylish the Familiar itself is. Commonplace Familiars such as mice often score low, while exotic and interesting creatures with colour and flair score higher.",
    ],
    prize: [
      "The two Warlocks with the highest scores each have a Dark Offering of their choice returned to them.",
      "The Warlock who had the most stylish Familiar receives a gold coin, even if they did not win the competition.",
    ],
  },
  {
    id: "ultimate-gladiator",
    name: "Ultimate Gladiator",
    description: [
      {
        type: "paragraph",
        text: "Warlocks duel in an arena in a single-elimination tournament, with victors moving up the brackets until only two undefeated fighters remain for the final duel.",
      },
      {
        type: "paragraph",
        text: "No healing is provided between bouts, but contestants are welcome to use all resources at their disposal between fights. No interference from spectators during fights is allowed.",
      },
    ],
    scoring: [
      "As soon as one combatant forfeits, combat ceases and victory is awarded to the other Warlock.",
      "Stepping outside the arena, or striking a spectator or opponent who has surrendered, is an instant loss.",
      "The judge has the power to instantly eliminate any competitor they feel is fighting in an unsporting manner.",
    ],
    prize: [
      "The two Warlocks who make it to the final round each have a Dark Offering of their choice returned to them.",
      "The Warlock who takes first place in the final duel receives a gold coin.",
    ],
  },
  {
    id: "ultimate-bard",
    name: "Ultimate Bard",
    description: [
      {
        type: "paragraph",
        text: "A poetry and short verse contest. Warlocks may submit a short verse (one page or less), and may either read it out themselves, or nominate a reader to perform it for them.",
      },
    ],
    scoring: [
      "This game's scoring system is based strongly on \"vibes\" — the judge will base their rankings on the execution of the artist's intent and the audience's applause.",
      "The judge may, at their discretion, invent brand new scoring metrics on the spot, such as awarding top places to the verses with the most rhymes, swear words, or simply the shortest ones.",
    ],
    prize: [
      "The two Warlocks with the winning submissions each have a Dark Offering of their choice returned to them.",
      "The Warlock who submits the worst verse receives a gold coin.",
    ],
  },
];
